export default __webpack_public_path__ + "static/media/Down.5f7f3984.svg";